import { ToastContainer } from "react-toastify";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoList from "./components/TodoList";

// css
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="grid place-items-center bg-blue-100 min-h-screen px-6 font-sans">
      <Navbar />

      <div
        className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white mt-4"
        style={{ marginTop: "5rem" }}
      >
        <Header />

        <hr className="mt-4" />

        <TodoList isComplete={false} />

        <hr className="mt-4" />

        <Footer />
      </div>
      <ToastContainer
        position="bottom-right"
        newestOnTop={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={1}
        autoClose={1500}
      />
    </div>
  );
}

export default App;
